<template>
    <div class="tab-pane active">
        <app-button v-if="$store.getters.canEditSettings" native-type="button" type="success" class="float-right" @click="$modal.show('create_addition')">
            {{ $t('Create') }}
        </app-button>
        <div class="clearfix"></div>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>{{ $t('Name') }}</th>
                        <th class="w-50">{{ $t('Comments') }}</th>
                        <th>{{ $t('Image') }}</th>
                        <th>{{ $t('Active') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <app-draggable v-model="reorderedAdditions" v-bind="{ animation: 200 }" tag="tbody">
                    <tr v-for="(addition, i) in reorderedAdditions" :key="i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ addition.name[locale] }}</td>
                        <td>{{ addition.comments[locale] }}</td>
                        <td>{{ addition.dbname ? $t('Yes') : '' }}</td>
                        <td>
                            <div class="custom-control custom-switch">
                                <input type="checkbox"
                                       class="custom-control-input"
                                       :id="`active_${i}`"
                                       :checked="addition.active || ''"
                                       @change="toggleActive(addition.id)">
                                <label class="custom-control-label" :for="`active_${i}`"/>
                            </div>
                        </td>
                        <td class="p-0">
                            <div class="text-right">
                                <router-link v-if="$store.getters.canViewSettings" :to="{name: 'additions.show', params: {addition_id: addition.id}}" class="btn btn-info btn-sm text-white">
                                    {{ $t('View') }}
                                </router-link>
                                <app-button v-if="$store.getters.canEditSettings" native-type="button" @click="$modal.show('update_addition', {addition})" class="ml-2" small>
                                    {{ $t('Edit') }}
                                </app-button>
                                <app-button v-if="$store.getters.canDeleteSettings" native-type="button" type="danger" @click="destroy(addition.id)" small>
                                    {{ $t('Delete') }}
                                </app-button>
                            </div>
                        </td>
                    </tr>
                </app-draggable>
            </table>
        </div>
        <create-modal @setAddition="setAddition"/>
        <update-modal @setAddition="setAddition"/>
    </div>
</template>

<script>
import AdditionService from '@services/addition.service';
import CreateModal from './modals/Create';
import UpdateModal from './modals/Update';
import {mapGetters} from 'vuex';
import Vue from 'vue';
import appDraggable from 'vuedraggable';

export default {
    data() {
        return {
            additions: []
        };
    },
    computed: {
        ...mapGetters(['locale']),
        eqs() {
            return this.additions;
        },
        reorderedAdditions: {
            get() {
                return this.eqs;
            },
            set(eqs) {
                AdditionService.reorder(eqs).then(res => {
                    this.$toastr.s(this.$t(res.message));
                    this.getAdditions();
                });
            }
        },
    },
    methods: {
        getAdditions() {
            AdditionService.additions().then(res => this.additions = res);
        },
        toggleActive(additionId) {
            AdditionService.toggleActive(additionId).then(res => {
                const add = this.additions.find(add => add.id === additionId);
                add.active = !add.active;
            });
        },
        setAddition(addition) {
            const index = this.additions.findIndex(add => add.id === addition.id);
            if(index !== -1) {
                Vue.set(this.additions, index, addition);
            } else {
                this.additions.push(addition);
            }
        },
        destroy(additionId) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            AdditionService.destroy(additionId).then(res => {
                const index = this.additions.findIndex(add => add.id === additionId);
                this.additions.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    components: {
        CreateModal,
        UpdateModal,
        appDraggable
    },
    created() {
        this.getAdditions();
    },
    metaInfo() {
        return {
            title: this.$t('Additional eq')
        };
    }
};
</script>
